<template>
  <div class="flex h-screen items-center justify-center">
    <LoadingSpinner class="inline h-20 w-20 text-gray-400" />
  </div>
</template>

<script setup>
import LoadingSpinner from './LoadingSpinner.vue'
</script>
